/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetMenuAssignmentRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetMenuAssignmentResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setMenuAssignment = (request: SetMenuAssignmentRequest, options?: CashRequestOptions) => post<SetMenuAssignmentRequest, SetMenuAssignmentResponse>("/2.0/cash/set-menu-assignment", request, {...options, rejectOnError: true })